// Paste each live listing URL. Empty URLs show an alert until you add them.

export const MARKETPLACES = [
  {
    id: "gumroad",
    name: "Gumroad",
    url: "https://prabhavdev.gumroad.com/l/one-person-ten-people",
  },
  {
    id: "payhip",
    name: "Payhip",
    url: "https://payhip.prabhavdev.com/one-person-ten-people",
  },
];

export const BOOK = {
  title: "One Person, Ten People",
  kicker: "A field manual for the age of leverage",
  subtitle:
    "How to become the person who can learn, build, research and execute almost anything",
  author: "Prabhav Dev",
  pages: 176,
  chapters: 15,
  edition: "First edition · 2026",
  salesPath: "/digital-products/ebooks/one-person-ten-people",
  slug: "one-person-ten-people",
  ebooksPath: "/digital-products/ebooks",
  hubPath: "/digital-products",
  stations: [
    "Research",
    "Learn",
    "Think",
    "Write",
    "Build",
    "Analyse",
    "Automate",
    "Sell",
  ],
  previewPoints: [
    "176-page digital-first field manual (6×9)",
    "15 chapters across three parts, plus sourced notes",
    "Eight-station loop: research through sell",
    "Ten-role audit, including Critic and Counsel",
    "18 adversarial prompts organised by station",
    "Verification playbook, worksheets, and a 90-day plan",
  ],
};

export function isMarketplaceLive(url) {
  return Boolean(url) && !/^https?:\/\/YOUR-/i.test(url);
}
